import { Text } from './Text';

export type { TextProps } from './types';
export default Text;
